export const PRODUCT_ID = 'product_id'
export const PRODUCT_DATA = 'product_data'
